import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=852b12b2&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=852b12b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852b12b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('852b12b2')) {
      api.createRecord('852b12b2', component.options)
    } else {
      api.reload('852b12b2', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=852b12b2&scoped=true&", function () {
      api.rerender('852b12b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HMtB83I6YR7n/JS/comp/PopupBox.vue"
export default component.exports